import { FC } from 'react';

import { ActEditingField } from 'utils/constants/admin';

import useTrls from 'hooks/translation/useTrls';

import { EditingData } from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingAct';
import EditingSelectorField from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingSelectorField/EditingSelectorField';
import { ActStatus } from 'components/Admin/Reports/ActsReport/Labels';

import { Act, ActStatus as ActStatusEnum } from 'store/models/acts';

import styles from 'components/Admin/Reports/ActsReport/ActsTable/Act/Act.module.less';

interface StatusProps {
    act: Act;
    onChange: (field: ActEditingField, value: string | undefined) => void;
    values: EditingData;
}
const Status: FC<StatusProps> = ({ act, onChange, values }) => {
    const { status } = act;
    const trl = useTrls();

    const dict = [
        {
            value: ActStatusEnum.ReadyTo1C,
            label: trl('admin.actsReport.statuses.ready'),
        },
        {
            value: ActStatusEnum.Invalid,
            label: trl('admin.actsReport.statuses.invalid'),
        },
    ];

    return (
        <div className={styles.tableCellGroup}>
            <b>{trl('admin.actsReport.actsTable.label.status')}: </b>
            <EditingSelectorField
                value={status}
                newValue={values[ActEditingField.Status]}
                setNewValue={(value) => onChange(ActEditingField.Status, value)}
                resetNewValue={() => onChange(ActEditingField.Status, undefined)}
                dictionary={dict}
            >
                <ActStatus status={status} />
            </EditingSelectorField>
        </div>
    );
};

export default Status;
